import { useListAllPlatformsMinimal } from '../../../../../../api-lib/src/gen/ops-portal-api';
import {
  Autocomplete,
  Button,
  Dialog,
  Divider,
  IconButton,
  TextField,
} from '@mui/material';
import React, { useState } from 'react';
import {
  PlatformProductFormWrapper,
  PlatformUidName,
} from './PlatformProductFormWrapper';
import Box from '@mui/system/Box';
import { AssignedPlatformProducts } from './AssignedPlatformProducts';
import { GridCloseIcon } from '@mui/x-data-grid-pro';
import * as uuid from 'uuid';

interface Props {
  readonly bankUid: string;
  readonly productUid: string;
  readonly open: boolean;
  readonly onClose: (event: object, reason: string) => void;
}

export const PlatformProductDialog = ({
  bankUid,
  productUid,
  open,
  onClose,
}: Props) => {
  const [platformToAdd, setPlatformToAdd] = useState<PlatformUidName | null>();
  const [selectedPlatforms, setSelectedPlatforms] = useState<PlatformUidName[]>(
    []
  );

  const platformOptions = useListAllPlatformsMinimal().data?.map(
    (platform) => ({
      label: platform.tradingName,
      value: platform.uid,
    })
  );

  const addPlatformToSelected = (
    platform: PlatformUidName | undefined
  ): void => {
    if (platform !== undefined) {
      setSelectedPlatforms((prevState) => {
        return [...prevState, platform];
      });
    }
  };

  const removePlatformFromSelected = (uniqueId: string): void => {
    setSelectedPlatforms((prevState) => {
      return prevState.filter((p) => p.uniqueId !== uniqueId);
    });
  };

  return (
    <Dialog maxWidth="xl" fullWidth open={open} onClose={onClose}>
      <Box
        sx={{
          width: 1,
          padding: '1rem',
          gap: '1rem',
          display: 'flex',
          flexDirection: 'column',
        }}>
        <Box display="flex">
          <Autocomplete
            sx={{ width: '25%', minWidth: '15rem' }}
            options={platformOptions ?? []}
            isOptionEqualToValue={(option, value) =>
              option.label === value.label
            }
            renderInput={(params) => <TextField {...params} label="Platform" />}
            onChange={(event, value) => {
              if (value?.value != null) {
                setPlatformToAdd({
                  uniqueId: uuid.v4(),
                  platformUid: value.value,
                  platformName: value.label,
                });
              }
            }}
          />
          <Button
            disabled={platformToAdd == null}
            onClick={() => {
              if (platformToAdd != null) {
                addPlatformToSelected({
                  uniqueId: platformToAdd.uniqueId,
                  platformUid: platformToAdd.platformUid,
                  platformName: platformToAdd.platformName,
                });
              }
            }}>
            Add Platform
          </Button>
        </Box>
        <IconButton
          aria-label="close"
          onClick={() => onClose({}, 'close')}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}>
          <GridCloseIcon />
        </IconButton>
        <Divider />
        {selectedPlatforms.map((platform, index) => {
          return (
            <PlatformProductFormWrapper
              key={platform.uniqueId}
              platform={platform}
              bankUid={bankUid}
              productUid={productUid}
              removePlatformFromSelected={removePlatformFromSelected}
            />
          );
        })}
        <Button
          sx={{ width: 'fit-content' }}
          onClick={() => setSelectedPlatforms([])}
          disabled={selectedPlatforms.length === 0}>
          Clear
        </Button>
      </Box>
      <Divider />
      <Box padding="0.5rem" height="600px">
        <AssignedPlatformProducts productUid={productUid} />
      </Box>
    </Dialog>
  );
};
